module.exports = __webpack_public_path__ + "static/media/goldbet-logo.ad34012c.svg";